import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, TextField, Tooltip } from '@mui/material';
import { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Controller, useForm } from 'react-hook-form';

export const CustomDialog = ({ formCode, onReject, isStatus }) => {
    // console.log(
    //     "status", isStatus
    // )
    const [open, setOpen] = useState(false);

    const { control, reset, getValues, formState: { errors, isDirty, isValid } } = useForm({
        mode: 'onChange',
        defaultValues: {
            comment: ''
        }
    })

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

     const handleReject = () => {
            onReject(formCode, getValues('comment'));
            handleClose();
    };

    return (
        <Box sx={{ pr: "1rem"}}>
            <Tooltip title={isStatus ? "Form status has already been updated" : "You can accept or reject form"} arrow>
                <div>
                    <Button variant="contained" color="error" onClick={handleClickOpen} disabled={isStatus}>
                        Reject
                    </Button>
                </div>
            </Tooltip>
            <Dialog open={open} onClose={handleClose} fullWidth>
                <DialogTitle>Are you sure you want to reject?
                    <IconButton style={{ position: 'absolute', right: '8px', top: '8px' }} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton></DialogTitle>
                <DialogContent >
                    <DialogContentText>
                        Please enter your comments below:
                    </DialogContentText>
                    <Controller
                        name="comment"
                        control={control}
                        rules={{ required: "Comment is required" }}
                        render={({ field }) => (<TextField
                            {...field}
                            autoFocus
                            margin="dense"
                            label="Comments"
                            multiline
                            rows={4}
                            fullWidth
                            error={errors["comment"] ? true : false}
                            helperText={errors["comment"] ? errors["comment"].message : ""}
                        />)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' onClick={handleClose} color="primary">
                        No
                    </Button>
                    <Button variant='contained' onClick={handleReject} color="primary" disabled={!isValid || !isDirty}>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

        </Box>

    );
};

export default CustomDialog;